// extracted by mini-css-extract-plugin
export var dateLabel = "_3r-0";
export var dateLabelError = "_3r-1";
export var fullWidth = "_3r-2";
export var smaller = "_3r-3";